import { IconClock, IconReaction } from '@xing-com/icons';
import { BodyCopy } from '@xing-com/typography';
import { useMediaListener, BREAKPOINTS } from '@xing-com/util';

import { BackButton } from '../../back-button';

import Logo from './assets/logo.webp';
import { TITLE } from './heading-section-data';
import {
  Container,
  Image,
  RightWrapper,
  TitleHandheld,
  TitleDesktop,
  InsightsWrapper,
  Insight,
  StyledLink,
  InsightBodyCopy,
  ArticleTypeTagsWrapper,
  ArticleTypeTag,
} from './heading-section.styles';

export const HeadingSection: React.FC = () => {
  const isMobile = useMediaListener() === BREAKPOINTS.handheld;

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ): void => {
    event.preventDefault();

    const targetSection = document.getElementById('insights-section');

    if (targetSection) {
      targetSection.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  return (
    <Container>
      <Image src={Logo} alt="bewerbung-page-logo" />
      <RightWrapper>
        {isMobile ? (
          <TitleHandheld size="xxlarge">{TITLE}</TitleHandheld>
        ) : (
          <>
            <BackButton />
            <TitleDesktop>{TITLE}</TitleDesktop>
          </>
        )}
        <InsightsWrapper>
          <Insight>
            <IconClock width={24} height={24} />
            <BodyCopy noMargin>10 minuten</BodyCopy>
          </Insight>
          <Insight>
            <IconReaction width={24} height={24} />
            <StyledLink to="#" onClick={handleClick}>
              <InsightBodyCopy noMargin>4 Insights</InsightBodyCopy>
            </StyledLink>
          </Insight>
          <Insight>
            <ArticleTypeTagsWrapper>
              <ArticleTypeTag>
                <BodyCopy size="small" noMargin>
                  Job & Karriere
                </BodyCopy>
              </ArticleTypeTag>
              <ArticleTypeTag>
                <BodyCopy size="small" noMargin>
                  Gehalt
                </BodyCopy>
              </ArticleTypeTag>
            </ArticleTypeTagsWrapper>
          </Insight>
        </InsightsWrapper>
      </RightWrapper>
    </Container>
  );
};
